
const CorpoClinicoStepForm =
[
    {
        key: 1,
        validateAllForms: false,
        mainStep: "GuideStep",
        steps: [
            { name: "GuideForm"},
        ]
    },
    {
        key: 2,
        validateAllForms: false,
        mainStep: "PersonalAddressDataStep",
        steps: [
            { name: "PersonalAddressDataForm"},
            { name: "PersonalDataForm" },
            { name: "AddressDataForm" }
        ]
    },
    {
        key: 3,
        validateAllForms: true,
        mainStep: "AcademicDegreeVocationalTraningStep",
        steps: [
            { name: "VocationalTraningForm" },
            { name: "AcademicDegreeForm" }
        ]
    },
    {
        key: 4,
        validateAllForms: false,
        mainStep: "BusinessAddressDataStep",
        steps: [
            { name: "BusinessDataForm" },
            { name: "BusinessAddressDataForm" }
        ]
    },
    {
        key: 5,
        validateAllForms: true,
        mainStep: "CorpoClinicoPhysicianRecommendationDataStep",
        steps: [
            { name: "PhysicianRecommendationDataForm" },
           
        ]
    },
    {
        key: 6,
        validateAllForms: true,
        mainStep: "CorpoClinicoInterestReasonsDataStep",
        steps: [
            { name: "InterestReasonsDataForm" },
           
        ]
    },
    {
        key: 7,
        validateAllForms: false,
        mainStep: "CorpoClinicoAttachmentDataStep",
        steps: [
            { name: "AttachmentForm" },
        ]
    },
    {
        key: 8,
        validateAllForms: false,
        mainStep: "TermsDeclarationsStep",
        steps: [
            { name: "TermsDeclarationsForm" },
            { name: "SupplierDeclarationForm" },
            { name: "RefusalPresentVaccineForm" }
           
        ]
    }

];


export { CorpoClinicoStepForm };